import { vysionTrack } from './vysionService';

export const setSocialVysion = (param: any): void => {
  switch (param.event) {
    case 'FACEBOOK':
      vysionTrack(param, 'footer-facebook');
      break;
    case 'TWITTER':
      vysionTrack(param, 'footer-twitter');
      break;
    case 'INSTAGRAM':
      vysionTrack(param, 'footer-instagram');
      break;
    case 'TERMS':
      vysionTrack(param, 'footer-terms');
      break;
    case 'TERMS-EU':
      vysionTrack(param, 'footer-terms-eu');
      break;
    case 'PRIVACY':
      vysionTrack(param, 'footer-privacy');
      break;
    case 'FAQ':
      vysionTrack(param, 'footer-faq');
      break;
    case 'BLOG':
      vysionTrack(param, 'footer-blog');
      break;
    case 'TIPS':
      vysionTrack(param, 'footer-tips');
      break;
    case 'COMMUNITY GUIDELINES':
      vysionTrack(param, 'footer-communityGuidelines');
      break;
    case 'GOOGLE SIGNUP':
      vysionTrack(param, 'join-signUpWithGoogle');
      break;
    case 'GOOGLE LOGIN':
      vysionTrack(param, 'login-loginWithGoogle');
      break;
    default:
      return;
  }
};
